import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Wall, CreateWallDto } from 'types';

export const createWall = ({
  data,
}: {
  data: CreateWallDto;
}): Promise<Wall> => {
  return axios.post('/api/walls', data);
};

type UseCreateWallOptions = {
  config?: MutationConfig<typeof createWall>;
};

export const useCreateWall = ({ config }: UseCreateWallOptions = {}) => {
  return useMutation({
    onMutate: async (newWall) => {
      await queryClient.cancelQueries(['walls']);

      const previousWalls = queryClient.getQueryData<Wall[]>(['walls']);

      queryClient.setQueryData(
        ['walls'],
        [...(previousWalls || []), newWall.data]
      );

      return { previousWalls };
    },
    onError: (_, __, context: any) => {
      if (context?.previousWalls) {
        queryClient.setQueryData(['walls'], context.previousWalls);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['walls']);
    },
    ...config,
    mutationFn: createWall,
  });
};
